import { generateCss } from './lib/generate-schema-css';

const $container = $('#landing-texts');
const $headings = $container.children('h1');
const $body = $(document.body);

let delayInSeconds = Number($container.data('slider-interval'));
if (!delayInSeconds || delayInSeconds <= 0) delayInSeconds = 5; // make sure if invalid it is equal to 5 seconds.

generateCss($headings);

// first hide all of them
$headings.css('opacity', '0');
$headings.first().css('opacity', '1');
$headings.css('position', 'absolute');

//set container height
function setContainerHeight () {
    $container.css('height', (() => {
        let height = 0;
        $headings.each((index, heading) => height = Math.max(height, $(heading).height()));
        return height;
    })() + 'px');
}

setContainerHeight();
window.addEventListener('resize', () => setContainerHeight());

(function performAnimation (prev, curr) {
    const $prev = $($headings.get(prev));
    const $curr = $($headings.get(curr));

    $body.removeClass($prev.data('color-schema'));
    $body.addClass($curr.data('color-schema'));

    $prev.css('opacity', '0');
    $curr.css('opacity', '1');

    setTimeout(() => performAnimation(curr, (curr+1) % $headings.length), delayInSeconds * 1000);
})($headings.length - 1, 0);
